import PropTypes from 'prop-types';
import { detailResponse } from './detalle.model';

export const mantenimientoModel = {
  eq: null,
  hi: null,
  fa: null,
  tc: null,
  nt: null,
  tm: null,
  dt: null,
  dm: null,
  im: null,
  sr: false,
  st: false,
  ts: [],
  pc: [],
  in: [],
};

export const maintenanceTestRequest = {
  ia: PropTypes.string.isRequired,
  eq: PropTypes.string.isRequired,
  so: PropTypes.string.isRequired,
  lr: new Array(testingDetailRequest),
};

export const testingDetailRequest = {
  co: PropTypes.string,
  tp: PropTypes.string,
  nt: PropTypes.string,
  rs: PropTypes.string,
  te: PropTypes.string,
  td: detailResponse,
};

export const maintenancePhotoRequest = {
  eq: PropTypes.string.isRequired,
  so: PropTypes.string.isRequired,
  ia: PropTypes.string.isRequired,
  nt: PropTypes.string,
  im: PropTypes.any,
};

export const maintenanceSupplieRequest = {
  ia: PropTypes.string.isRequired,
  eq: PropTypes.string.isRequired,
  so: PropTypes.string.isRequired,
  li: new Array(supplieDetailRequest),
};

export const supplieDetailRequest = {
  mt: PropTypes.string.isRequired,
  ct: PropTypes.number.isRequired,
};

export const maintenanceRequest = {
  ia: PropTypes.string.isRequired,
  so: PropTypes.string.isRequired,
  dt: new Array(maintenanceEquipmentRequest),
};

export const maintenanceEquipmentRequest = {
  eq: PropTypes.string.isRequired,
  tm: PropTypes.string.isRequired,
  dt: PropTypes.string.isRequired,
  rc: PropTypes.string,
  sr: PropTypes.bool,
};
